import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-column-options',
  templateUrl: './table-column-options.component.html',
  styleUrls: ['./table-column-options.component.scss'],
})
export class TableColumnOptionsComponent implements OnInit {

  @Input() optionsData: any;
  @Input() onPathSelected!: (data: any) => void;

  options: any;
  id: any;

  constructor() { }

  ngOnInit() {
    this.options = this.optionsData.options;
    this.id = this.optionsData.idKey;
  }

  // Navigate to path
  routeToPath(path: any) {
    this.onPathSelected({ id: this.id, path: path });
  }
}
